import type { LinhaDeProgresso } from './tipos';

/**
 * O progresso geral da Season, numa conta só — e num lugar só.
 *
 * <p>Mora aqui, e não em cada tela, por uma lição já paga: enquanto o menu carregava a
 * própria régua e a página carregava outra, um dizia 16/49 e o outro 16/21. Os dois
 * estavam certos dentro da própria conta e errados juntos. Régua duplicada diverge —
 * é só questão de quando.
 *
 * <p><b>`feito` entra limitado pela meta.</b> Sem o teto, as 48 cartas de uma meta de 30
 * pagariam sozinhas o atraso de três coleções vazias, e o número geral diria que o mundo
 * está pronto enquanto metade dele não existe. Excesso numa linha não é adiantamento nas
 * outras.
 *
 * <p>Linha sem meta fica de fora das duas somas: ela não tem alvo, então não há fração
 * que ela possa cumprir nem atrasar.
 *
 * @returns nulo quando nenhuma meta foi combinada — não há régua, e fingir 0% seria
 *     dizer que o time está atrasado num prazo que ninguém marcou.
 */
export function progressoGeral(
  linhas: LinhaDeProgresso[]
): { feito: number; meta: number; pct: number } | null {
  const comMeta = linhas.filter((l) => l.meta > 0);
  if (comMeta.length === 0) return null;

  const meta = comMeta.reduce((s, l) => s + l.meta, 0);
  const feito = comMeta.reduce((s, l) => s + Math.min(l.feito, l.meta), 0);
  return { feito, meta, pct: Math.round((feito / meta) * 100) };
}
